import React from "react";
import { Icon, LightButton, AnchorLink } from "best-common-react";
import { Card, CardBody } from "reactstrap";
import styled from "styled-components";
import PropTypes from "prop-types";
import { DesktopTabletView, MobileView } from "best-common-react";

// eslint-disable-next-line react/prefer-stateless-function
class DeleteTempSectionFormatter extends React.Component {
  render() {
    const { index, canDelete, onDelete } = this.props.value;
    const desktopDeleteOverrideId = `desktop-delete-override_${index}`;

    if (!canDelete) {
      return null;
    } else {
      return (
        <div>
          <Icon
            id={desktopDeleteOverrideId}
            className="flex-fill text-center mx-1"
            iconName="fa-trash-alt"
            onClick={onDelete}
          />
        </div>
      );
    }
  }
}

DeleteTempSectionFormatter.propTypes = {
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func
};

export default DeleteTempSectionFormatter;
